import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router';
import { usePermission } from '../../auth/permissions';
import { PageHeader } from '../../components/PageHeader';

/** Settings: tabs for Users and Your account (more come with later stages). */
export function SettingsPage() {
  const canSeeUsers = usePermission('users.view');
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const canSeeOrgs = usePermission('organisations.view');
  const canPrice = usePermission('tariffs.edit');
  const canSticker = usePermission('chargers.edit');
  const canKeys = usePermission('apikeys.manage');
  const tabs = [
    ...(canSeeOrgs ? [{ to: '/settings/organisations', label: 'Organisations' }] : []),
    ...(canPrice ? [{ to: '/settings/peak-hours', label: 'Peak and off-peak' }] : []),
    ...(canSeeUsers ? [{ to: '/settings/people', label: 'Users' }] : []),
    ...(canSticker ? [{ to: '/settings/qr-stickers', label: 'QR stickers' }] : []),
    ...(canKeys ? [{ to: '/settings/api-keys', label: 'API keys' }] : []),
    { to: '/settings/account', label: 'Your account' },
  ];
  const current = tabs.find((t) => pathname.startsWith(t.to))?.to ?? false;

  if (pathname === '/settings' || pathname === '/settings/') return <Navigate to={tabs[0]!.to} replace />;

  return (
    <>
      <PageHeader title="Settings." lead="Organisations, users and your account." />
      <Tabs value={current} onChange={(_e, to: string) => navigate(to)} aria-label="Settings sections" variant="scrollable" allowScrollButtonsMobile sx={{ mb: 4 }}>
        {tabs.map((t) => (
          <Tab key={t.to} value={t.to} label={t.label} />
        ))}
      </Tabs>
      <Outlet />
    </>
  );
}

export function AccountTab({ children }: { children: React.ReactNode }) {
  return (
    <Box>
      <Typography variant="h2">Change your password.</Typography>
      <Typography color="textSecondary" sx={{ mt: 0.5, mb: 3 }}>
        You will need your current one.
      </Typography>
      {children}
    </Box>
  );
}
